import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "@emotion/styled";
import { useCustomTheme } from "../../../../../../core/design-system/CustomThemeProvider.js";
import { iconSize, spacing, } from "../../../../../../core/design-system/index.js";
import { Spacer } from "../../../../components/Spacer.js";
import { Container, Line, ModalHeader } from "../../../../components/basic.js";
import { Button } from "../../../../components/buttons.js";
import { Text } from "../../../../components/text.js";
import { currencies } from "./currencies.js";
export function CurrencySelection(props) {
    return (_jsxs(Container, { children: [_jsx(Container, { p: "lg", children: _jsx(ModalHeader, { title: "Pay with", onBack: props.onBack }) }), _jsx(Line, {}), _jsx(Spacer, { y: "lg" }), _jsx(Container, { flex: "column", gap: "xs", px: "lg", children: currencies.map((c) => {
                    return (_jsxs(SelectCurrencyButton, { fullWidth: true, variant: "secondary", onClick: () => props.onSelect(c), gap: "sm", children: [_jsx(c.icon, { size: iconSize.lg }), _jsxs(Container, { flex: "column", gap: "xxs", children: [_jsx(Text, { color: "primaryText", children: c.shorthand }), _jsx(Text, { size: "sm", children: c.name })] })] }, c.shorthand));
                }) }), _jsx(Spacer, { y: "lg" })] }));
}
const SelectCurrencyButton = /* @__PURE__ */ styled(Button)(() => {
    const theme = useCustomTheme();
    return {
        background: theme.colors.tertiaryBg,
        justifyContent: "flex-start",
        gap: spacing.sm,
        padding: spacing.sm,
        "&:hover": {
            background: theme.colors.secondaryButtonBg,
            transform: "scale(1.01)",
        },
        transition: "background 200ms ease, transform 150ms ease",
    };
});
//# sourceMappingURL=CurrencySelection.js.map